import type { BaseTicketWithId, CustomerOptions } from "@/resources/ticket";
import type { Filter } from "@/utils/apiFilter";
import { apiClient } from "./apiClient";

class LearnerTicketService {
  async list(
    learnerId: string,
    filter: Filter = {},
  ): Promise<BaseTicketWithId[]> {
    try {
      const response = await apiClient.get<BaseTicketWithId[]>(
        `/learners/${learnerId}/tickets`,
        { ...filter, limit: 1000 },
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      console.warn(
        "Learner tickets API returned unexpected status:",
        response.status,
      );
      return [];
    } catch (error) {
      console.error("Failed to fetch tickets:", error);
      return [];
    }
  }

  async getById(
    learnerId: string,
    ticketId: string,
  ): Promise<BaseTicketWithId | null> {
    try {
      const response = await apiClient.get<BaseTicketWithId>(
        `/learners/${learnerId}/tickets/${ticketId}`,
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      console.warn(
        "Learner ticket API returned unexpected status:",
        response.status,
      );
      return null;
    } catch (error) {
      console.error("Failed to fetch ticket:", error);
      return null;
    }
  }

  async updateById(
    learnerId: string,
    ticketId: string,
    data: Partial<CustomerOptions>,
  ): Promise<boolean> {
    try {
      const response = await apiClient.put<BaseTicketWithId>(
        `/learners/${learnerId}/tickets/${ticketId}`,
        { customerOptions: data },
      );
      return response.status === "OK";
    } catch (error) {
      console.error("Failed to fetch ticket:", error);
      return false;
    }
  }
}

export const learnerTicketService = new LearnerTicketService();
